import { render, staticRenderFns } from "./CmgNavItem.vue?vue&type=template&id=01ee527b&scoped=true&lang=pug&"
import script from "./cmg-nav-item.ts?vue&type=script&lang=ts&"
export * from "./cmg-nav-item.ts?vue&type=script&lang=ts&"
import style0 from "./CmgNavItem.vue?vue&type=style&index=0&id=01ee527b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ee527b",
  null
  
)

export default component.exports